import DefaultLayout from '@/layout/DefaultLayout.vue'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/file',
    component: DefaultLayout,
    children: [{
      path: '',
      name: 'file-preview',
      component: () => import('@/views/file-preview/index.vue'),
      meta: {
        title: '文件预览',
        requiresAuth: false,
      }
    }]
  }
]

export default routes
